import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'firstNameToName',
})
export class FirstNameToNamePipe implements PipeTransform {
  transform(value: unknown): unknown {
    if (!value) return 'First Name';
    return 'Name';
  }
}
